import React from "react";
import { useTranslation } from "react-i18next";
import { useCalcPriceQuery } from "../../../api/queries/priceQueries";
import { useMoney } from "../../../hooks/useMoney";
import { mappingBookingState2RequestDTO } from "../../../mapping/mappingBookingState2RequestDTO";
import { mergeClass } from "../../../utils/common";
import { CartRowInfo } from "./CartRowInfo";
import { CartRowQuantity } from "./CartRowQuantity";

type CartItemRowProps = {
  bookingState: SelectableBooking;
  voucherId?: number;
  vari: "READONLY" | "EDIT";
  onSelectItem?: (card: BookingState, checked: boolean) => void;
  setDelSingle?: (id: string) => void;
};

const CartItemRow: React.FC<CartItemRowProps> = (props) => {
  const { bookingState, vari, onSelectItem } = props;
  const handleSetBookingRequest = (
    id: string,
    fieldName: keyof BookingInfo,
    value: any,
  ) => {
    // TODO: cart handleSetBookingRequest
    console.log("handleSetBookingRequest");
  };

  //TODO: Implement the logic to display the card
  // const packageDisplay = card.productType === 'PASS' && '3 choices' ;
  // const dateAndTime = Utils.formatDate(card.formInfo?.date ? new Date(card.formInfo.date) : undefined);
  // const guest = card.formInfo?.qtyGuestAdult || card.formInfo?.qtyGuestChild &&
  //  card.formInfo?.qtyGuestAdult + ' adults, ' + card.formInfo?.qtyGuestChild + ' child';
  // const dataPackage = card.selectedVariant.attributes?.find((attr) => attr?.attributeType === 'DATA_PACKAGE')?.value;;
  // const simValidity = card.selectedVariant.attributes?.find((attr) => attr?.attributeType === 'SIM_VALIDITY')?.value;

  // const packageDisplay = card.product.name;
  // const dateAndTime = Utils.formatDate(
  //   card.bookingInfo?.date ? new Date(card.bookingInfo.date) : undefined
  // );
  // const guest = card.bookingInfo?.qtyAdult || card.bookingInfo?.qtyChild;
  // const cardInfo = [
  //   {
  //     title: "Package",
  //     value: packageDisplay,
  //   },
  //   {
  //     title: "Date and time",
  //     value: dateAndTime,
  //   },
  //   {
  //     title: "Guest",
  //     value: guest,
  //   },
  // ];
  return (
    <div
      className={mergeClass(
        "flex flex-col flex-wrap justify-between gap-y-2.5 rounded-2xl border-b border-l border-r border-t border-[#DCDCDC] px-4 py-4 sm:py-8",
        vari === "EDIT"
          ? "sm:rounded-none sm:border-b-0 sm:border-l-0 sm:border-r-0 sm:px-0"
          : "",
        bookingState.status === "EXPIRED" ? "opacity-50" : "",
      )}
    >
      <div
        data-id={bookingState.id}
        data-bookgroupno={bookingState.bookGroupNo}
        className="flex flex-wrap justify-between gap-y-2.5 sm:flex-nowrap"
      >
        <div className="flex gap-4">
          {(true || vari === "EDIT") && (
            <div className="flex content-center pt-10">
              {bookingState.status === "EXPIRED" ? (
                <span className="rounded-[6.1875rem] bg-[#BFC5C9] px-2 py-[0.5625rem] text-[0.875rem] font-normal leading-[1.1919rem] text-white">
                  Expired
                </span>
              ) : (
                <span></span>
                // <input
                //   className="custom-checkbox"
                //   type="checkbox"
                //   checked={!!bookingState.checked}
                //   onChange={(e) =>
                //     onSelectItem?.(bookingState, e.target.checked)
                //   }
                // />
              )}
            </div>
          )}
          <CartRowInfo {...props} />
        </div>
        <div className="ml-auto flex flex-col gap-3 sm:ml-1">
          <CartRowQuantity {...props} />
        </div>
      </div>
      {vari === "READONLY" && <CartRowTotal {...props} />}
    </div>
  );
};

const CartRowTotal = (props: CartItemRowProps) => {
  const { t } = useTranslation();
  const { formatMoney } = useMoney();
  const { bookingState } = props;
  const bookingPrice = useCalcPriceQuery([
    mappingBookingState2RequestDTO(bookingState, {
      voucherId: props.voucherId,
    }),
  ]);
  const voucher = bookingPrice.data?.priceOfSingleBookings[0]?.voucher;
  const originalTotalAmount = bookingPrice?.data?.originalTotalAmount;
  const cartTotal = bookingPrice?.data?.cartTotal;

  return (
    <div className="mt-2 flex flex-col border-t border-[#DCDCDC] pt-4 sm:mt-4 sm:pt-8">
      {voucher && (
        <span className="mb-2 text-end text-base text-[#007AFF]">
          {t("Applied")} {t("Promote code")}{" "}
          {voucher.discountType === "FIXED"
            ? formatMoney(voucher.discountValue)
            : `${voucher.discountValue}%`}
        </span>
      )}

      <span className="ml-auto flex items-baseline gap-2 text-base text-[#232323]">
        {t("Total")}
        {originalTotalAmount && originalTotalAmount !== cartTotal && (
          <span className="normal text-[#BFC5C9] line-through">
            {formatMoney(originalTotalAmount)}
          </span>
        )}

        <span className="text-lg font-semibold">{formatMoney(cartTotal)}</span>
      </span>
    </div>
  );
};
export default CartItemRow;
